import React from 'react';
import Button from '@material-ui/core/Button';

const TheButton = props => <Button disableElevation {...props} />;

export default TheButton;
